import { render, staticRenderFns } from "./profile-mono-create-eds-key.vue?vue&type=template&id=6b86a68a&scoped=true&lang=pug"
import script from "./profile-mono-create-eds-key.vue?vue&type=script&lang=js"
export * from "./profile-mono-create-eds-key.vue?vue&type=script&lang=js"
import style0 from "./profile-mono-create-eds-key.vue?vue&type=style&index=0&id=6b86a68a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b86a68a",
  null
  
)

export default component.exports